import Icon from 'components/Icon';
import Select from 'components/Inputs/Select';
import MainButton from 'components/MainButton';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTE_FIRE } from 'utils/constants/routes';

interface FireHeaderComponentProps {
  currentOrganizationId: number;
  organizations: { id: number; name: string }[];
  isDetailView: boolean;
  switchOrganization: (organizationId: string) => void;
  setShowSettings: (showSettings: boolean) => void;
  editable: boolean;
}

const FireHeaderComponent: React.FC<FireHeaderComponentProps> = ({
  organizations,
  isDetailView,
  currentOrganizationId,
  switchOrganization,
  setShowSettings,
  editable
}) => {
  return (
    <div className="fire-header-component">
      <div className="fire-header-component__organization fire-header-component__button">
        <Select
          name="organization"
          value={currentOrganizationId}
          onChange={(e) => switchOrganization(e.target.value)}
          fireFont={true}
          rounded={true}
          light={true}
        >
          {organizations.map((org) => (
            <option key={org.id} value={org.id}>
              {org.name}
            </option>
          ))}
        </Select>
      </div>

      <div className="fire-header-component__settings">
        <div className="fire-header-component__new">
          {isDetailView && (
            <Link to={ROUTE_FIRE + '/' + currentOrganizationId}>
              <MainButton rounded={true}>
                <FormattedMessage id="new fire" />
              </MainButton>
            </Link>
          )}
        </div>

        {editable && (
          <div className="fire-header-component__button">
            <button
              type="button"
              aria-label="Settings"
              onClick={() => setShowSettings(true)}
            >
              <Icon name="slider" size="medium" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FireHeaderComponent;
